import * as trans from "../common/Translator";
import * as ShowImageIn from "../constants/ShowImageIn";
import {isEmptyOrNull, isNullOrUndefined} from "./NamaCommon";
import * as DownloadPurpose from "../constants/DownloadPurpose";
import {previewImageCode} from "../views/list/ListViewColumns";
import {calcForecolor, colorCode, shouldAddMainFileWidget} from "./GUIUtilities";
import {getEntityImageInfo} from "../login/ClientCache";
import {calcMainFileWidthPercent} from "../views/edit/EditScreenGroup";
import * as GUIDevMode from "../constants/GUIDevMode";

export function downloadURLBrRecordId(id, entityType, purpose, redirect) {
    return downloadURL_("recordId", id, entityType, purpose, redirect);
}

export function downloadURL(id, entityType, purpose, redirect) {
    return downloadURL_("fileID", id, entityType, purpose, redirect);
}

export function downloadURL_(paramId, id, entityType, purpose, redirect) {
    let redirectVal = "&redirect=" + redirect;
    if (redirect)
        redirectVal = "";
    let url = GUIDevMode.APP_URL + "file.download?" + paramId + "=" + id + (purpose != null ? "&purpose=" + purpose : "") + redirectVal + "&entitytype="
        + entityType + "&locale=" + (trans.isArabic() ? "ar" : "en") + "&nocahce=" + Date.now();
    return url;
}

export function calcMainFileID(record) {
    if (!record.mainFile)
        return null;
    return record.mainFile.attachmentInfo.fileId;
}

export function mainFileImgTagByRecordID(record, showImageIn, mainFileContainer) {
    return mainFileImgTag(record.entityType, calcMainFileID(record), showImageIn, record.id, true, mainFileContainer, false, record);
}

export function recordHasImage(record) {
    if (!record)
        return false;
    if (record.hasImage)
        return true;
    let fileSize = record["mainFile.fileSize"];
    if (fileSize)
        return true;
    if (!record.mainFile)
        return false;
    return !isNullOrUndefined(record.mainFile.dataLength) || !isNullOrUndefined(record.mainFile.fileSize);
}

export function mainFileImgTag(entityType, attachmentId, showImageIn, recordId, byRecordId, mainFileContainer, isMainFileImg, record) {
    if ((isMainFileImg && !shouldAddMainFileWidget(entityType)) || (!isMainFileImg && !shouldShowImage(entityType, showImageIn)))
        return "";
    if (!recordHasImage(record))
        return emptyOrSolidImg(isMainFileImg);
    let existImgDiv = undefined;
    if (mainFileContainer) {
        let mainFileImage = mainFileContainer.find("#mainFileImage");
        existImgDiv = mainFileImage.length ? mainFileImage[0] : undefined;
    }
    if (existImgDiv)
        existImgDiv.remove();
    if (isEmptyOrNull(attachmentId) && !byRecordId)
        return emptyOrSolidImg(isMainFileImg);
    let w = getWidth(entityType, showImageIn);
    let h = getHeight(entityType, showImageIn);
    if (!w)
        w = 64;
    if (!h)
        h = 64;
    if (isMainFileImg)
        w = 300, h = 300;
    let url = downloadURL(attachmentId, entityType, "THUMBNAIL", false);
    if (byRecordId)
        url = downloadURLBrRecordId(recordId, entityType, DownloadPurpose.THUMBNAIL, false)
    let img = $(`<div class="employee-img"><img class="w-100" id ="mainFileImage" src ='${url}' onload='onMainImageLoad(this,"${w}","${h}",${isMainFileImg},"${entityType}");' ${previewImageCode(entityType, recordId, attachmentId)}/></div>`);
    if (showImageIn !== ShowImageIn.Suggestion && showImageIn !== ShowImageIn.HeaderFields)
        img.css("display", "block");
    return img;
}

function emptyOrSolidImg(isMainFileImg) {
    if (!isMainFileImg)
        return "";
    else
        return $(`<div class="employee-img"><img class="w-100" id ="mainFileImage" src ='assets/namasoft/img/image-solid.png'/></div>`);
}

function setHeightAndWidthOfImg(element, h, w) {
    $(element).height(h);
    $(element).parent().height(h);
    $(element).width(w);
    $(element).parent().width(w);
}

function setHeightAndWidthOfMainFile(element, entityType) {
    let parentHeight = $(element).closest("#mainFileContainer").height();
    let percentOfHeight = (80 * parentHeight) / 100;
    parentHeight = Math.max(percentOfHeight, (parentHeight - 150))
    let parentWidth = $(element).closest("#mainFileContainer").width();
    if (element.naturalHeight > element.naturalWidth) {
        $(element).height(parentHeight);
        $(element).width(null);
    } else {
        $(element).width(percentOf($(element).closest("#mainFileContainer").width(), entityType));
        $(element).height(null);
    }
    $(element).parent().css("background-color", "transparent");
    $(element).parent().css("border", "0px");
}

function percentOf(offsetWidth, entityType) {
    return ((calcMainFileWidthPercent(entityType) || 90) * offsetWidth) / 100;
}

window.onMainImageLoad = function (element, w, h, isMainImage, entityType) {
    if (element.naturalHeight === 1)
        $(element).remove();
    if (isMainImage)
        setHeightAndWidthOfMainFile(element, entityType);
    else
        setHeightAndWidthOfImg(element, h, w);
    let grid = $(element).closest(".k-grid");
    if (grid && grid.data("kendoGrid"))
        grid.data("kendoGrid")._resize();
};


export function shouldShowImage(entityType, showImageIn) {
    let entityImageInfo = getEntityImageInfo(entityType);
    if (!entityImageInfo)
        return false;
    switch (showImageIn) {
        case ShowImageIn.GridSeparateColumn:
            return entityImageInfo.showInSeparateColumn === true;
        case ShowImageIn.GridColumns:
            return entityImageInfo.useInGridColumns === true;
        case ShowImageIn.ListView:
            return entityImageInfo.useInList === true;
        case ShowImageIn.SearcherView:
            return entityImageInfo.useInSearch === true;
        case ShowImageIn.Suggestion:
            return entityImageInfo.useInSuggestion === true;
        case ShowImageIn.HeaderFields:
            return entityImageInfo.useInHeaderFields === true;
    }
    return false;
}

function getWidth(entityType, showIn) {
    let entityImageInfo = getEntityImageInfo(entityType);
    switch (showIn) {
        case ShowImageIn.GridColumns:
            return entityImageInfo.widthInGridColumns;
        case ShowImageIn.GridSeparateColumn:
            return entityImageInfo.widthOfSeparateColumns;
        case ShowImageIn.ListView:
            return entityImageInfo.widthInList;
        case ShowImageIn.SearcherView:
            return entityImageInfo.widthInSearcher;
        case ShowImageIn.Suggestion:
            return entityImageInfo.widthInSuggestion;
        case ShowImageIn.HeaderFields:
            return entityImageInfo.widthInHeaderFields;
    }
    return 64;
}

function getHeight(entityType, showIn) {
    let entityImageInfo = getEntityImageInfo(entityType);
    switch (showIn) {
        case ShowImageIn.GridColumns:
            return entityImageInfo.heightInGridColumns;
        case ShowImageIn.GridSeparateColumn:
            return entityImageInfo.heightOfSeparateColumns;
        case ShowImageIn.ListView:
            return entityImageInfo.heightInList;
        case ShowImageIn.SearcherView:
            return entityImageInfo.heightInSearcher;
        case ShowImageIn.Suggestion:
            return entityImageInfo.heightInSuggestion;
        case ShowImageIn.HeaderFields:
            return entityImageInfo.heightInHeaderFields;
    }
    return 64;
}

export function addImgPartToName(refEntityType, refId, otherPart, showIn, ref) {
    if (!refEntityType || !refId)
        return otherPart;
    let container = $(`<div></div>`);
    if (otherPart.contains("</")) {
        let partJQuery = $(otherPart);
        if (ref && ref.colorCode) {
            partJQuery.css("background-color", colorCode(ref));
            partJQuery.css("color", calcForecolor(colorCode(ref)));
        }
        container.append(partJQuery);
    } else {
        container.append(otherPart);
    }
    container.append(mainFileImgTag(refEntityType, null, showIn, refId, true, undefined, undefined, ref));
    return container.html();
}